"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBLIC_API_URL = exports.PRIVATE_API_URL = void 0;
exports.PRIVATE_API_URL = 'https://manage.wix.com/_api/vod/private/graphql';
exports.PUBLIC_API_URL = '/_api/vod/public/graphql';
//# sourceMappingURL=constants.js.map